import { render, staticRenderFns } from "./PageTaskbar.vue?vue&type=template&id=52cf980f&scoped=true&"
import script from "./PageTaskbar.vue?vue&type=script&lang=js&"
export * from "./PageTaskbar.vue?vue&type=script&lang=js&"
import style0 from "./PageTaskbar.vue?vue&type=style&index=0&id=52cf980f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf980f",
  null
  
)

export default component.exports